type Level = "fatal" | "error" | "warn" | "info" | "debug" | "trace" | "event";

const elasticFormat = (o: {
  time: Date,
  message: string,
  level: Level,
  [key: string]: any
}) => {
  let { time, message, level, ...rest } = o;
  return { "@timestamp": time.toISOString(), level, message, ...rest } as { [key: string]: any }
}

type TransmitFunction = (entry: { [key: string]: any }) => void;

export interface LogOptions {
  transmit: TransmitFunction,
  enableConsole: boolean,
  dateTimeNow: () => Date
}
export class Log {
  sessionId: string;
  opts?: LogOptions

  constructor() {
    this.sessionId = "_unknown_";
  }

  setLogOptions(options: LogOptions) {
    this.opts = options
  }

  setSessionId(id: string) {
    this.sessionId = id;
  }
  getSessionId() {
    return this.sessionId
  }

  createLogFunction(level: Level) {
    const self = this;
    return function <T extends object>(msg: string, obj?: T) {
      let logObject = {
        time: self.opts?.dateTimeNow() || new Date(),
        message: msg || '',
        level,
        sessionId: self.sessionId
      };
      if (obj) {
        logObject = { ...logObject, ...obj }
      }
      let ecsFormat = elasticFormat(logObject)
      self.opts?.transmit(ecsFormat)
      if (self.opts?.enableConsole) console.log(logObject)
    }
  }
  fatal = this.createLogFunction('fatal');
  error = this.createLogFunction('error');
  warn = this.createLogFunction('warn');
  info = this.createLogFunction('info');
  debug = this.createLogFunction('debug');
  trace = this.createLogFunction('trace');
  event = this.createLogFunction('event');
}

export const log = new Log()
export type Logger = typeof log;